import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What are Android app development services?",
    answer: `<p>Android app development services are designed to offer complete support throughout every stage of an app's life cycle, including ideation, design, development, quality assurance, and publishing on the Google Play store.</p>`,
  },
  {
    question: "How long does it take to develop an Android app?",
    answer: `<p>The development process of an Android app is quite diverse based on different phases of its whole creation. However, considering the engineering process, along with design and development – the duration of a regular application can be around 4-6 months. Meanwhile, applications with a wide scale and custom functions may take up to 12 months.</p>`,
  },
  {
    question: "What is the cost of developing an Android app?",
    answer: `<p>The cost of developing an Android app can vary significantly. Industry estimates suggest that basic Android apps may cost between $25,000 and $250,000. However, more complex and feature-rich apps can range from $50,000 to $500,000 or higher, depending on the project's specifications.</p>`,
  },
  {
    question:
      "Does TekRevol offer a free consultation or quote for Android app development?",
    answer: `<p>Yes, you can connect with us and our professional Android app developers who are ready to facilitate you with a free Android app development consultation. You can discuss all your project requirements and the ideas you have in mind. The experts in our company will ensure to provide you with a pathway. Further, we can also help you to decode your idea into a practical approach to app development.</p>`,
  },
  {
    question:
      "Does TekRevol offer ongoing support and maintenance for Android apps?",
    answer: `<p>Being a trusted Android app development agency, we offer complete support and maintenance to our clients even after the project completion. We perform regular analysis of your app performance and gather factual data to help you understand its overall impact on your business.</p>`,
  },
  {
    question: "Will I be getting any support after project completion?",
    answer: `<p>We never leave our clients on their own after the project completion as there is a constant support and maintenance service that you can avail to maintain the sustainability of your application. Especially, when you deploy custom Android app development, there is always a need for support to further enhance and alter the features based on the increasing requirements of the audience. It will enable you to overcome any flaw that may arise after the application is live.</p>`,
  },
  {
    question: "Why should you hire an Android app development company?",
    answer: `<p>Mobile app developers possess extensive experience and skills that will significantly benefit your project at every stage. You can leverage their expertise to gain the full potential of cloud integration and mobile technology.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Android App Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
